"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const kendo_react_grid_1 = require("@progress/kendo-react-grid");
const card_1 = require("components/molecules/card");
const grid_style_1 = __importDefault(require("./grid.style"));
const constants_1 = require("utils/constants");
const pagination_1 = __importDefault(require("components/templates/pagination"));
const store_1 = require("store");
function isFilterDescriptor(f) {
    return 'operator' in f;
}
const ComponentGrid = (_a) => {
    var { dataGrid, dataStates, editField, style, columns, onTakeChange, fullScreen, onPageChange, onFilterChange, pageable } = _a, props = __rest(_a, ["dataGrid", "dataStates", "editField", "style", "columns", "onTakeChange", "fullScreen", "onPageChange", "onFilterChange", "pageable"]);
    const [rowheight, setRowHeight] = (0, react_1.useState)(20);
    (0, react_1.useEffect)(() => {
        const [gridElement] = document.getElementsByClassName('k-widget k-grid no-scrollbar');
        if (gridElement) {
            const containerHeight = gridElement.clientHeight;
            const height = containerHeight / (dataGrid.length + 3);
            setRowHeight(height < 30 ? undefined : height);
            if (dataGrid.length < 10)
                setRowHeight(40);
        }
    }, [dataGrid]);
    const pageSize = dataStates.take > dataGrid.length ? dataGrid.length : dataStates.take;
    const pagination = (props) => {
        return (0, jsx_runtime_1.jsx)(pagination_1.default, Object.assign({}, props, { onPageChange: onPageChange, onTakeChange: onTakeChange }));
    };
    const nativeOnFilterChange = (e) => {
        const filters = [];
        if (e.filter) {
            e.filter.filters.forEach(item => {
                if (isFilterDescriptor(item))
                    filters.push(item);
            });
            const filterEvent = Object.assign(Object.assign({}, e), { filter: Object.assign(Object.assign({}, e.filter), { filters }) });
            if (onFilterChange)
                onFilterChange(filterEvent);
        }
        else {
            const filterEvent = Object.assign(Object.assign({}, e), { filter: undefined });
            if (onFilterChange)
                onFilterChange(filterEvent);
        }
    };
    const _dumpTruckCell = (props) => {
        const itemData = props.dataItem;
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: itemData.dataChild.length > 0 ? ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `m_grid_cell_dump_truck_${props.dataIndex}` }, { children: itemData.dataChild.map((item, idx) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [item.dumptruck_no, idx === itemData.dataChild.length - 1 ? '' : ', '] }, idx))) }))) : (0, jsx_runtime_1.jsx)("td", {}) }));
    };
    const cellRender = (cell, props) => {
        const { field, dataIndex } = props;
        const itemData = props.dataItem;
        if (field === 'contractor_name') {
            const tmp = dataGrid.filter(i => i.contractor_name == itemData.contractor_name);
            if (dataIndex - dataStates.skip == 0) {
                if (tmp.length > 0) {
                    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ style: grid_style_1.default.cellStyle, rowSpan: tmp.length }, { children: itemData[field].toString() })));
                }
            }
            else {
                if (itemData.contractor_name != dataGrid[dataIndex - dataStates.skip - 1].contractor_name && tmp.length > 0) {
                    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ style: grid_style_1.default.cellStyle, rowSpan: tmp.length }, { children: itemData[field].toString() })));
                }
                else if (itemData.contractor_name == dataGrid[dataIndex - dataStates.skip - 1].contractor_name) {
                    return null;
                }
            }
        }
        if (field === 'area_name') {
            const tmp = dataGrid
                .filter(i => i.contractor_name == itemData.contractor_name && i.area_name == itemData.area_name);
            if (dataIndex - dataStates.skip == 0) {
                if (tmp.length > 0) {
                    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ style: grid_style_1.default.cellStyle, rowSpan: tmp.length }, { children: itemData[field].toString() })));
                }
            }
            else {
                if ((itemData.contractor_name != dataGrid[dataIndex - dataStates.skip - 1].contractor_name ||
                    itemData.area_name != dataGrid[dataIndex - dataStates.skip - 1].area_name) && tmp.length > 0) {
                    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ style: grid_style_1.default.cellStyle, rowSpan: tmp.length }, { children: itemData[field].toString() })));
                }
                else if (itemData.area_name == dataGrid[dataIndex - dataStates.skip - 1].area_name) {
                    return null;
                }
            }
        }
        return cell;
    };
    return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(kendo_react_grid_1.Grid, Object.assign({ data: dataGrid, editField: editField, rowHeight: rowheight, scrollable: dataStates.scrollable, pageSize: pageSize, take: dataStates.take, total: dataStates.total, skip: dataStates.skip, className: fullScreen ? 'no-scrollbar full-scren-grid' : 'no-scrollbar', style: style, sortable: false, filterable: false, reorderable: dataStates.reorderable, sort: dataStates.sort, pageable: pageable, filterOperators: constants_1.customFilterOperator, pager: pageable ? pagination : undefined, onFilterChange: nativeOnFilterChange, cellRender: cellRender }, props, { children: columns.filter(x => x.show).map((column, index) => {
                var _a;
                return (((_a = column.field) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'dump_truck' ? ((0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, Object.assign({ cell: _dumpTruckCell }, column), index)) : ((0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, Object.assign({}, column), index)));
            }) })) }));
};
const GridComponent = (_a) => {
    var { dataGrid, dataStates, editField, style, columns, pageable, cardGrid = true, onTakeChange, onPageChange, onFilterChange } = _a, props = __rest(_a, ["dataGrid", "dataStates", "editField", "style", "columns", "pageable", "cardGrid", "onTakeChange", "onPageChange", "onFilterChange"]);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: cardGrid ? ((0, jsx_runtime_1.jsx)(card_1.Card, Object.assign({ style: grid_style_1.default.cardGridStyle(appTheme) }, { children: (0, jsx_runtime_1.jsx)(card_1.CardBody, { children: (0, jsx_runtime_1.jsx)(ComponentGrid, Object.assign({ style: style, columns: columns, pageable: pageable, dataGrid: dataGrid, editField: editField, dataStates: dataStates, onTakeChange: onTakeChange, onPageChange: onPageChange, onFilterChange: onFilterChange }, props)) }) }))) : ((0, jsx_runtime_1.jsx)(ComponentGrid, Object.assign({ style: style, columns: columns, pageable: pageable, dataGrid: dataGrid, editField: editField, dataStates: dataStates, onTakeChange: onTakeChange, onPageChange: onPageChange, onFilterChange: onFilterChange }, props))) }));
};
exports.default = GridComponent;
